// @ts-nocheck
/* ==========================================================================
   El Buen Fin MX 2026 — captação de lead (Shopify + HubSpot em um único envio)
   Base: hot-sale-form.js (LP Hot Sale CO), com as correções da LP Cyber Monday AR.
   Campanha exclusiva da loja México: telefone sempre +52.

   Telefone (México):
   - o campo mostra SEMPRE o número nacional de 10 dígitos, formatado enquanto
     a pessoa digita: 55 1234 5678 (CDMX/GDL/MTY) · 222 123 4567 (demais cidades);
   - o que não faz parte do número nacional sai na hora: "+52", o "1" antigo de
     celular, "044"/"045" e "01";
   - a validação roda a cada tecla: mostra quantos dígitos faltam e marca o
     campo como válido, sem esperar o envio.

   Fluxo do submit:
   1) valida os campos;
   2) preenche os campos ocultos que o form de cliente da Shopify recebe;
   3) posta na HubSpot Forms Submission API v3 (keepalive, timeout de 4 s);
      se a HubSpot recusar com 400, reenvia uma vez só com os dados de contato;
   4) libera o envio nativo com form.requestSubmit() DENTRO de setTimeout(…, 0)
      (necessário para o hCaptcha da loja; form.submit() gera "Missing CAPTCHA token").

   Dados não se perdem:
   - scripts de terceiros (ex.: Meta Pixel) chamam form.submit() direto, pulando a
     validação; a Shopify recebia o form sem telefone e recarregava a página vazia.
     form.submit() agora só passa depois do nosso fluxo (guardNativeSubmit);
   - nome, e-mail e telefone ficam guardados na sessão e voltam para os campos se
     a página recarregar com erro da Shopify.
   ========================================================================== */
(function () {
  'use strict';

  var HUBSPOT_TIMEOUT_MS = 4000;
  var HS_SENT_KEY = 'mxbf_hs_sent';
  var HS_SENT_TTL_MS = 10 * 60 * 1000;
  var DRAFT_KEY = 'mxbf_draft';
  var DRAFT_TTL_MS = 30 * 60 * 1000;

  // México: DDI 52; número nacional = 10 dígitos (código de área + número).
  var MX_DIAL = '52';
  var MX_LEN = 10;
  // Códigos de área de 2 dígitos (CDMX, Guadalajara, Monterrey); os outros têm 3.
  var MX_AREA2 = ['55', '56', '33', '81'];

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var UTM_STORAGE_KEY = 'mxbf_utm';

  // Campos enviados no reenvio após 400 (sem enums de origem).
  var CORE_FIELDS = ['email', 'firstname', 'lastname', 'phone', 'nacionalidade', 'madesa_email_consent'];

  // ---------------------------------------------------------------- telefone

  // Devolve só os dígitos nacionais (no máximo 10). Enquanto a pessoa digita o
  // começo de "+52 1 …", devolve { pending } para não apagar o que ela escreve.
  // Nenhum código de área do México começa com 0, 1 ou 52: esses começos são
  // sempre prefixo, nunca parte do número.
  function mxNormalize(value) {
    var raw = String(value || '');
    var d = raw.replace(/\D/g, '');
    var hasPlus = raw.replace(/\s/g, '').charAt(0) === '+';

    if (hasPlus && d === '5') return { pending: d }; // "+5": ainda vem o "2"
    if (d === '52' || d === '521') return { pending: d };
    if (d.indexOf(MX_DIAL) === 0) {
      d = d.slice(MX_DIAL.length);
      if (d.charAt(0) === '1') d = d.slice(1); // "1" antigo de celular (+52 1 …)
    }
    // 044/045 (prefixo antigo de celular) e 01 (longa distância antiga).
    // "0" e "04" ainda podem virar 044/045: espera o próximo dígito.
    if (d === '0' || d === '04') return { pending: d };
    if (/^04[45]/.test(d)) d = d.slice(3);
    d = d.replace(/^[01]+/, '');
    return { digits: d.slice(0, MX_LEN) };
  }

  function mxDigits(value) {
    return mxNormalize(value).digits || '';
  }

  function mxAreaLength(d) {
    return MX_AREA2.indexOf(d.slice(0, 2)) > -1 ? 2 : 3;
  }

  function mxFormat(value) {
    var n = mxNormalize(value);
    if (n.pending) return n.pending.charAt(0) === '0' ? n.pending : '+' + n.pending.replace(/^52(1)$/, '52 $1');
    var d = n.digits;
    var L = mxAreaLength(d);
    if (d.length <= L) return d;
    var rest = d.slice(L);
    var first = L === 2 ? 4 : 3; // 55 1234 5678 · 222 123 4567
    return d.slice(0, L) + ' ' + (rest.length > first ? rest.slice(0, first) + ' ' + rest.slice(first) : rest);
  }

  // '' = válido · 'empty' · 'short' = faltam dígitos · 'fake' = número repetido
  function mxPhoneError(value) {
    var d = mxDigits(value);
    if (!d) return 'empty';
    if (d.length < MX_LEN) return 'short';
    if (/^(\d)\1+$/.test(d)) return 'fake';
    return '';
  }

  function mxE164(value) {
    var d = mxDigits(value);
    return d.length === MX_LEN ? '+' + MX_DIAL + d : '';
  }

  // Reformata mantendo o cursor depois do mesmo dígito (edição no meio do número).
  function applyPhoneMask(input) {
    var before = input.value;
    var formatted = mxFormat(before);
    if (before === formatted) return;
    var focused = document.activeElement === input && typeof input.selectionStart === 'number';
    var caret = focused ? input.selectionStart : before.length;
    input.value = formatted;
    if (!focused) return;

    var typedBefore = before.slice(0, caret).replace(/\D/g, '').length;
    // Dígitos de prefixo removidos (+52, 1, 0…) não contam para a posição.
    var removed = before.replace(/\D/g, '').length - formatted.replace(/\D/g, '').length;
    var target = Math.max(0, typedBefore - Math.max(0, removed));
    var pos = 0;
    var seen = 0;
    while (pos < formatted.length && seen < target) {
      if (/\d/.test(formatted.charAt(pos))) seen++;
      pos++;
    }
    try { input.setSelectionRange(pos, pos); } catch (e) {}
  }

  // ---------------------------------------------------------------- helpers

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function splitFullName(fullName) {
    var parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return { firstname: '', lastname: '' };
    return { firstname: parts[0], lastname: parts.slice(1).join(' ') };
  }

  function getHubspotUtk() {
    var match = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
    return match ? decodeURIComponent(match[2]) : '';
  }

  function readUtmsFromUrl() {
    var utms = {};
    try {
      var params = new URLSearchParams(window.location.search);
      UTM_KEYS.forEach(function (key) {
        var value = (params.get(key) || '').trim();
        if (value) utms[key] = value;
      });
    } catch (e) {}
    return utms;
  }

  function persistUtms() {
    var fromUrl = readUtmsFromUrl();
    if (!Object.keys(fromUrl).length) return;
    try { sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(fromUrl)); } catch (e) {}
  }

  function getUtms() {
    var fromUrl = readUtmsFromUrl();
    if (Object.keys(fromUrl).length) return fromUrl;
    try {
      var stored = sessionStorage.getItem(UTM_STORAGE_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      return {};
    }
  }

  function markHubspotSent() {
    try { sessionStorage.setItem(HS_SENT_KEY, String(Date.now())); } catch (e) {}
  }

  function hubspotRecentlySent() {
    try {
      var ts = Number(sessionStorage.getItem(HS_SENT_KEY) || 0);
      return ts > 0 && Date.now() - ts < HS_SENT_TTL_MS;
    } catch (e) {
      return false;
    }
  }

  function saveDraft(data) {
    try {
      data.ts = Date.now();
      sessionStorage.setItem(DRAFT_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function readDraft() {
    try {
      var data = JSON.parse(sessionStorage.getItem(DRAFT_KEY) || 'null');
      if (data && Date.now() - (data.ts || 0) < DRAFT_TTL_MS) return data;
    } catch (e) {}
    return null;
  }

  function field(name, value) {
    return { objectTypeId: '0-1', name: name, value: String(value) };
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // ------------------------------------------------------------------ form

  function initForm(form) {
    if (!form || form.dataset.mxbfInit === 'true') return;
    form.dataset.mxbfInit = 'true';

    var successUrl = form.dataset.successUrl || '';
    var shopifyErrors = form.querySelector('[data-mxbf-shopify-errors]');

    // Erro da Shopify (ex.: telefone já usado por outro cliente) depois de o lead
    // já ter chegado à HubSpot: leva para a página de sucesso em vez de travar.
    if (shopifyErrors && hubspotRecentlySent() && successUrl) {
      try { sessionStorage.removeItem(HS_SENT_KEY); } catch (e) {}
      window.location.replace(successUrl);
      return;
    }

    var STR = {};
    var i18nEl = form.querySelector('[data-mxbf-i18n]');
    if (i18nEl) {
      try { STR = JSON.parse(i18nEl.textContent); } catch (e) { STR = {}; }
    }

    var nameInput = form.querySelector('[data-mxbf-name]');
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var phoneInput = form.querySelector('[data-mxbf-phone]');
    var consentInput = form.querySelector('[data-mxbf-consent]');
    var statusEl = form.querySelector('[data-mxbf-status]');
    var submitBtn = form.querySelector('[data-mxbf-submit]');
    var submitLabel = form.querySelector('[data-mxbf-submit-label]');
    var submitLabelDefault = submitLabel ? submitLabel.textContent.trim() : '';

    var firstNameField = form.querySelector('input[name="contact[first_name]"]');
    var lastNameField = form.querySelector('input[name="contact[last_name]"]');
    var phoneField = form.querySelector('input[name="contact[phone]"]');

    var consentRequired = !!(consentInput && consentInput.dataset.required === 'true');

    var hsPortalId = (form.dataset.hsPortalId || '').trim();
    var hsFormId = (form.dataset.hsFormId || '').trim();
    var hsNacionalidade = (form.dataset.hsNacionalidade || '').trim();
    var hsOrigem = (form.dataset.hsOrigemStaging || '').trim();

    var submitting = false;

    var MSG = {
      required: STR.validationRequired || 'Completa todos los campos.',
      name: STR.validationName || 'Escribe tu nombre completo.',
      email: STR.validationEmail || 'Escribe un correo electrónico válido.',
      phone: STR.validationPhone || 'Escribe un celular de 10 dígitos (ej.: 55 1234 5678).',
      phoneFake: 'Revisa tu número: parece incorrecto.',
      consent: STR.validationConsent || 'Debes aceptar recibir las comunicaciones para continuar.',
      retry: 'No pudimos completar tu registro. Revisa tus datos e inténtalo de nuevo.',
    };

    // Mensagem por campo, criada pelo JS (não depende de mexer no Liquid).
    function hintFor(input) {
      if (!input || !input.parentNode) return null;
      var hint = input.parentNode.querySelector('.mxbf-form__hint');
      if (!hint) {
        hint = document.createElement('span');
        hint.className = 'mxbf-form__hint';
        hint.id = (form.id || 'mxbf') + '-hint-' + Math.random().toString(36).slice(2, 7);
        hint.setAttribute('aria-live', 'polite');
        hint.hidden = true;
        input.insertAdjacentElement('afterend', hint);
        input.setAttribute('aria-describedby', hint.id);
      }
      return hint;
    }

    // state: '' (neutro) · 'valid' · 'invalid'
    function setFieldState(input, state, message) {
      if (!input) return;
      input.setAttribute('aria-invalid', state === 'invalid' ? 'true' : 'false');
      input.classList.toggle('is-valid', state === 'valid');
      var hint = hintFor(input);
      if (!hint) return;
      hint.textContent = message || '';
      hint.classList.toggle('is-error', state === 'invalid');
      hint.hidden = !message;
    }

    function showStatus(message) {
      if (!statusEl) return;
      statusEl.textContent = message || '';
      statusEl.hidden = !message;
    }

    function setSubmitting(state) {
      submitting = state;
      if (submitBtn) submitBtn.disabled = state;
      if (submitLabel) submitLabel.textContent = state ? STR.submitLoading || 'Enviando...' : submitLabelDefault;
    }

    // ----- validação por campo. Devolve '' (ok) ou a mensagem de erro.
    // strict = false: enquanto digita — só orienta, não pinta de vermelho
    //                 um campo que a pessoa ainda está preenchendo.

    function checkName(strict) {
      if (!nameInput) return '';
      var v = nameInput.value.trim();
      if (v.length >= 3) { setFieldState(nameInput, 'valid', ''); return ''; }
      var msg = v ? MSG.name : MSG.required;
      setFieldState(nameInput, strict ? 'invalid' : '', strict ? msg : '');
      return msg;
    }

    function checkEmail(strict) {
      if (!emailInput) return '';
      var v = emailInput.value.trim();
      if (isValidEmail(v)) { setFieldState(emailInput, 'valid', ''); return ''; }
      var msg = v ? MSG.email : MSG.required;
      setFieldState(emailInput, strict ? 'invalid' : '', strict ? msg : '');
      return msg;
    }

    function checkPhone(strict) {
      if (!phoneInput) return '';
      var err = mxPhoneError(phoneInput.value);
      if (!err) { setFieldState(phoneInput, 'valid', ''); return ''; }
      if (err === 'fake') { setFieldState(phoneInput, 'invalid', MSG.phoneFake); return MSG.phoneFake; }
      if (err === 'empty') {
        setFieldState(phoneInput, strict ? 'invalid' : '', strict ? MSG.required : '');
        return MSG.required;
      }
      if (strict) {
        setFieldState(phoneInput, 'invalid', MSG.phone);
      } else {
        var missing = MX_LEN - mxDigits(phoneInput.value).length;
        setFieldState(phoneInput, '', missing === 1 ? 'Falta 1 dígito.' : 'Faltan ' + missing + ' dígitos.');
      }
      return MSG.phone;
    }

    function checkConsent(strict) {
      if (!consentRequired) return '';
      if (consentInput.checked) { consentInput.setAttribute('aria-invalid', 'false'); return ''; }
      if (strict) consentInput.setAttribute('aria-invalid', 'true');
      return MSG.consent;
    }

    // Valida tudo; devolve a 1ª mensagem de erro e foca o 1º campo inválido.
    function validate() {
      var checks = [
        [nameInput, checkName(true)],
        [emailInput, checkEmail(true)],
        [phoneInput, checkPhone(true)],
        [consentInput, checkConsent(true)],
      ];
      for (var i = 0; i < checks.length; i++) {
        if (checks[i][0] && checks[i][1]) {
          try { checks[i][0].focus(); } catch (e) {}
          return checks[i][1];
        }
      }
      return '';
    }

    function storeDraft() {
      saveDraft({
        name: nameInput ? nameInput.value : '',
        email: emailInput ? emailInput.value : '',
        phone: phoneInput ? mxDigits(phoneInput.value) : '',
      });
    }

    function buildHubSpotFields(data) {
      var fields = [field('email', data.email), field('firstname', data.firstname)];
      if (data.lastname) fields.push(field('lastname', data.lastname));
      if (data.phoneDigits) fields.push(field('phone', data.phoneDigits));
      // Só envia quando marcado: "false" apagaria um opt-in anterior.
      if (!consentInput || consentInput.checked) fields.push(field('madesa_email_consent', 'true'));
      if (hsNacionalidade) fields.push(field('nacionalidade', hsNacionalidade));
      if (hsOrigem) {
        fields.push(field('origem_de_cadastro_staging', hsOrigem));
        fields.push(field('origem_de_cadastro__crm__staging', hsOrigem));
        fields.push(field('fuente_de_registro__mexico_', hsOrigem));
      }
      // UTM vazia não entra: string vazia apagaria a atribuição anterior.
      var utms = getUtms();
      UTM_KEYS.forEach(function (key) {
        if (utms[key]) fields.push(field(key, utms[key]));
      });
      return fields;
    }

    function postToHubSpot(fields) {
      var context = { pageUri: window.location.href, pageName: document.title || window.location.pathname };
      var hutk = getHubspotUtk();
      if (hutk) context.hutk = hutk; // hutk vazio faz a API rejeitar

      return fetch(
        'https://api.hsforms.com/submissions/v3/integration/submit/' + hsPortalId + '/' + hsFormId,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ fields: fields, context: context }),
          keepalive: true,
        }
      ).then(function (res) {
        return res.json().catch(function () { return null; }).then(function (body) {
          return { ok: res.ok, status: res.status, body: body };
        });
      });
    }

    // Resolve sempre: uma falha na HubSpot não pode impedir a gravação na Shopify.
    function sendToHubSpot(fields) {
      if (!hsPortalId || !hsFormId) return Promise.resolve();

      return postToHubSpot(fields)
        .then(function (r) {
          if (r.ok) { markHubspotSent(); return; }
          console.error('[mx-buenfin] HubSpot recusou o envio', r.status, r.body);
          if (r.status !== 400) return;
          var core = fields.filter(function (f) { return CORE_FIELDS.indexOf(f.name) > -1; });
          return postToHubSpot(core).then(function (r2) {
            if (r2.ok) {
              markHubspotSent();
              console.warn('[mx-buenfin] Lead enviado sem origem/UTM. Confira as opções de origem no CRM.');
            } else {
              console.error('[mx-buenfin] Reenvio recusado', r2.status, r2.body);
            }
          });
        })
        .catch(function (err) {
          console.error('[mx-buenfin] Falha ao enviar para a HubSpot', err);
        });
    }

    function releaseNativeSubmit() {
      // setTimeout é obrigatório: se a HubSpot resolver na hora, a chamada cairia
      // dentro do evento de submit em andamento e seria ignorada pelo navegador.
      setTimeout(function () {
        form.dataset.mxbfReady = 'true';
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          nativeFormSubmit.call(form);
        }
      }, 0);
    }

    // ----- devolve os dados digitados se a página voltou com erro da Shopify

    var cameBackWithError = !!shopifyErrors || (!!form.id && window.location.hash === '#' + form.id);
    if (cameBackWithError) {
      var draft = readDraft();
      if (draft) {
        if (nameInput && !nameInput.value) nameInput.value = draft.name || '';
        if (emailInput && !emailInput.value) emailInput.value = draft.email || '';
        if (phoneInput && !phoneInput.value) phoneInput.value = draft.phone || '';
      }
      if (shopifyErrors) showStatus(MSG.retry);
    }

    // ----- listeners (registrados uma única vez)

    if (phoneInput) {
      // Folga para colar/autocompletar "+52 1 55 …"; o que fica no campo são 10 dígitos.
      phoneInput.setAttribute('maxlength', '20');
      phoneInput.addEventListener('input', function () {
        applyPhoneMask(phoneInput);
        checkPhone(false);
        showStatus('');
        storeDraft();
      });
      // change = preenchimento automático do navegador.
      phoneInput.addEventListener('change', function () { applyPhoneMask(phoneInput); checkPhone(false); });
      // Ao sair do campo com número incompleto, o aviso vira erro.
      phoneInput.addEventListener('blur', function () {
        applyPhoneMask(phoneInput);
        if (phoneInput.value.trim()) checkPhone(true);
      });
      applyPhoneMask(phoneInput);
      if (phoneInput.value) checkPhone(cameBackWithError);
    }

    [[nameInput, checkName], [emailInput, checkEmail]].forEach(function (pair) {
      var input = pair[0];
      var check = pair[1];
      if (!input) return;
      // Enquanto digita: tira o erro e marca válido assim que estiver certo.
      input.addEventListener('input', function () {
        check(input.dataset.touched === 'true' && input.getAttribute('aria-invalid') === 'true');
        showStatus('');
        storeDraft();
      });
      // Ao sair do campo preenchido: mostra o erro, se houver.
      input.addEventListener('blur', function () {
        if (!input.value.trim()) return;
        input.dataset.touched = 'true';
        check(true);
      });
      if (input.value) check(cameBackWithError);
    });

    if (consentInput) {
      consentInput.addEventListener('change', function () { checkConsent(false); showStatus(''); });
    }

    form.addEventListener('submit', function (event) {
      // 2ª passada (requestSubmit): deixa a Shopify e o hCaptcha seguirem.
      if (form.dataset.mxbfReady === 'true') return;

      event.preventDefault();
      if (submitting) return;

      if (phoneInput) applyPhoneMask(phoneInput);
      var error = validate();
      if (error) {
        showStatus(error);
        return;
      }
      showStatus('');
      storeDraft();

      var nome = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var e164 = phoneInput ? mxE164(phoneInput.value) : '';
      var names = splitFullName(nome);

      if (firstNameField) firstNameField.value = names.firstname || nome;
      if (lastNameField) lastNameField.value = names.lastname;
      if (phoneField) phoneField.value = e164;

      setSubmitting(true);

      var hubspot = sendToHubSpot(
        buildHubSpotFields({
          email: email,
          firstname: names.firstname || nome,
          lastname: names.lastname,
          phoneDigits: e164.replace(/\D/g, ''),
        })
      );

      Promise.race([hubspot, wait(HUBSPOT_TIMEOUT_MS)]).then(releaseNativeSubmit);
    });

    // Página restaurada pelo botão "voltar" (bfcache): reabilita o form.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        form.dataset.mxbfReady = 'false';
        setSubmitting(false);
      }
    });
  }

  // Scripts de terceiros (ex.: Meta Pixel fbevents.js) chamam form.submit()
  // direto, o que pula o evento de submit, a validação e a HubSpot: a Shopify
  // recebe o form sem telefone e recarrega a página vazia. Nos formulários da LP,
  // form.submit() só passa depois do nosso fluxo (data-mxbf-ready="true");
  // nos demais formulários da loja nada muda.
  var nativeFormSubmit = HTMLFormElement.prototype.submit;
  function guardNativeSubmit() {
    if (HTMLFormElement.prototype.submit.__mxbfGuard) return;
    var guarded = function () {
      if (this && this.hasAttribute && this.hasAttribute('data-mxbf-form') && this.dataset.mxbfReady !== 'true') {
        console.warn('[mx-buenfin] form.submit() externo ignorado até a validação terminar.');
        return;
      }
      return nativeFormSubmit.apply(this, arguments);
    };
    guarded.__mxbfGuard = true;
    HTMLFormElement.prototype.submit = guarded;
  }

  // A tag {% form %} da Shopify grava a âncora do formulário na action
  // (/contact#MxbfForm-…) e o navegador a mantém após o redirecionamento:
  // /pages/el-buen-fin-gracias#MxbfForm-template--…__hero. Na página de sucesso
  // o formulário não existe: limpa a URL (e o rascunho, já que o envio deu certo).
  // Na página que voltou com erro, o formulário existe: mantém a âncora para a
  // rolagem levar a pessoa até ele.
  function cleanFormHash() {
    var hash = window.location.hash || '';
    if (hash.indexOf('#MxbfForm-') !== 0) return;
    var id = hash.slice(1);
    try { id = decodeURIComponent(id); } catch (e) {}
    if (document.getElementById(id)) return;
    try { sessionStorage.removeItem(DRAFT_KEY); } catch (e) {}
    if (window.history && history.replaceState) {
      history.replaceState(history.state, '', window.location.pathname + window.location.search);
    }
  }

  function boot(root) {
    cleanFormHash();
    guardNativeSubmit();
    persistUtms();
    (root || document).querySelectorAll('[data-mxbf-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });

  // Exposto só para testes automatizados (não usado pela página).
  window.__mxbfPhone = { normalize: mxNormalize, format: mxFormat, error: mxPhoneError, e164: mxE164 };
})();
